import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const TeacherViewModal = ({ isOpen, onClose, teacher, loading }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="modal-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.85, y: 60 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.85, y: 60 }}
          onClick={(e) => e.stopPropagation()}
          style={{
            maxWidth: "640px",
            borderRadius: "16px",
            padding: "32px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <h3 style={{ margin: "0 0 28px", fontSize: "24px", fontWeight: 700 }}>
            O‘qituvchi ma'lumotlari
          </h3>

          {loading ? (
            <div style={{ textAlign: "center", padding: "100px 0" }}>
              Yuklanmoqda...
            </div>
          ) : teacher ? (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              {/* Rasm */}
              <div style={{ textAlign: "center" }}>
                {teacher.imageUrl ? (
                  <img
                    src={teacher.imageUrl}
                    alt={teacher.fullName}
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "4px solid #e0e7ff",
                      boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/180?text=No+Image";
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "180px",
                      height: "180px",
                      borderRadius: "50%",
                      background: "#e0e7ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "60px",
                      fontWeight: "bold",
                      color: "#6366f1",
                      margin: "0 auto",
                    }}
                  >
                    {teacher.fullName?.[0]?.toUpperCase() || "?"}
                  </div>
                )}
              </div>

              <div style={{ display: "grid", gap: "16px" }}>
                <div>
                  <strong>Ism Familya:</strong> {teacher.fullName || "—"}
                </div>
                <div>
                  <strong>Lavozim:</strong> {teacher.position || "—"}
                </div>
                <div>
                  <strong>Bio / Tavsif:</strong>
                  <p
                    style={{
                      margin: "8px 0 0",
                      whiteSpace: "pre-wrap",
                      lineHeight: 1.6,
                    }}
                  >
                    {teacher.bio || "Ma'lumot kiritilmagan"}
                  </p>
                </div>
                <div>
                  <strong>ID:</strong>{" "}
                  <span style={{ fontFamily: "monospace", fontSize: "14px" }}>
                    {teacher.id}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "80px 0",
                color: "#e74c3c",
              }}
            >
              Ma'lumot topilmadi
            </div>
          )}

          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <button
              onClick={onClose}
              style={{
                padding: "10px 24px",
                background: "#f1f5f9",
                border: "none",
                borderRadius: "8px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Yopish
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TeacherViewModal;
